/**
 * Automatické přidání do košíku V B2B po změnění hodnoty v košíku
 */
FNC.addCartCategory.b2bFormInput = () => {
    [...document.getElementsByClassName('b2b-input')].forEach(element => {
        element.addEventListener('keydown', e => {
            if (e.key === '-' || e.key === '+') {
                e.preventDefault();

            }

        })

        element.addEventListener('keyup', e => {
            if (e.target.value < 0) {
                e.target.value = ''

            }

        });



        element.addEventListener('change', e => {
            const
                value = e.target.value === '' ? 0 : e.target.value,
                form = ID[e.target.form.id],
                data = {
                    'productId': e.target.dataset.variant,
                    'quantity': value
                };

            naja.makeRequest('POST', form.dataset.link, data, {
                spinner: false
            }).then(r => {

                [...document.getElementsByClassName('b2b-input')].forEach(input => {
                    input.setAttribute('disabled', true);

                });

                e.target.classList.add('added')
                setTimeout(() => {
                    e.target.classList.remove('added');
                    [...document.getElementsByClassName('b2b-input')].forEach(input => {
                        input.removeAttribute('disabled');

                    });
                }, 1500);
            });


        });

    });

};

/**
 * Přepsání ceny podle vybrané varianty
 */
FNC.addCartCategory.priceBySelectVariant = () => {
    document.querySelectorAll('.card-product').forEach(el => {
        let price = el.querySelector('.price');
        if (price) {
            if (!_.isEmpty(el.querySelectorAll('input[type=radio]'))) {
                el.querySelectorAll('input[type=radio]').forEach(input => {
                    if (input.checked) {
                        price.querySelectorAll('.priceFrom').forEach(el => el.hidden = true);

                    }

                    input.addEventListener('click', e => {

                        const originalPriceAct = e.target.getAttribute('originalpricevat');
                        const priceAct = e.target.getAttribute('pricevat');

                        if (!_.isNull(priceAct)) {
                            price.querySelectorAll('.priceFrom').forEach(el => el.hidden = true);
                            if (!_.isNull(price.querySelector(".originalPriceVat")) && !_isNull(originalPriceAct)) {
                                price.querySelector(".originalPriceVat").innerHTML = originalPriceAct;

                            }

                            if (!_.isNull(price.querySelector(".priceVat")) && !_.isNull(priceAct)) {
                                price.querySelector(".priceVat").innerHTML = priceAct;

                            }

                        }

                    });

                });

            } else {
                el.querySelectorAll('select').forEach(select => {
                    if (!_.isEmpty(select.value)) {
                        price.querySelectorAll('.priceFrom').forEach(el => el.hidden = true);

                    }

                    select.addEventListener('change', e => {
                        const
                            variantsPrices = JSON.parse(e.target.dataset.variantsPrices),
                            variantPrice = variantsPrices[e.target.value];

                        price.querySelectorAll('.priceFrom').forEach(el => el.hidden = true);
                        price.querySelector(".originalPriceVat").innerHTML = variantPrice.originalPrice;
                        price.querySelector(".priceVat").innerHTML = variantPrice.price;

                    });

                });

            }


        }
    });
}


document.addEventListener('DOMContentLoaded', () => {
    FNC.addCartCategory.b2bFormInput();
    FNC.addCartCategory.priceBySelectVariant();
});

naja.addEventListener('success', () => {
    FNC.addCartCategory.b2bFormInput();
    FNC.addCartCategory.priceBySelectVariant();
})

FNC.addCartCategory.selectedVariant = (link) => {
    naja.makeRequest(
        'POST',
        link,
        null
    )

}